import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "text-3xl font-black text-white text-center w-8/12" }, "Login to your account", -1)
const _hoisted_2 = { class: "w-full align-middle mt-[50px] flex flex-col gap-6 bg-white shadow-base h-full rounded-t-3xl px-5 py-10" }
const _hoisted_3 = { class: "flex justify-between flex-wrap gap-2" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("a", {
  href: "/reset-password",
  class: "text-primary-violet"
}, "Forgot password?", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "flex mt-2 w-full justify-center" }, [
  /*#__PURE__*/_createElementVNode("div", { id: "googleButton" })
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "bg-light-gray-100 w-full flex justify-center items-center py-5 rounded-b-3xl" }, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createTextVNode("Not yet on Workbean? "),
    /*#__PURE__*/_createElementVNode("a", {
      class: "text-primary-violet font-bold",
      href: "/signup"
    }, "Sign up")
  ])
], -1)

import { ref, watch, onUpdated, onMounted } from "vue"
  import { generateSchema } from "@/utils/validate"
  import { IonPage } from "@ionic/vue"
  import { useGtm } from "@gtm-support/vue-gtm"
  import { useAuthenticationStore } from "@/store/authentication"
  import * as jwt from "@/utils/jwt"

  import WbTemplate from "@/components/account-creation/template.vue"
  import WbInput from "@/components/template/InputTemplate.vue"
  import WbPassword from "@/components/template/PasswordTemplate.vue"
  import WbCheckbox from "@/components/template/CheckboxTemplate.vue"
  import FormContainer from "@/components/template/formTemplate.vue"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'LoginPage',
  setup(__props) {

  const authenticationStore = useAuthenticationStore()
  const gtm = useGtm()

  const validationSchema = generateSchema([
    {
      name: "email",
      rule: "email",
    },
    {
      name: "password",
      rule: "stringRequired",
    },
  ])

  const email = ref("")
  const password = ref("")

  /**
   * calls for login api defined in authentication store
   */
  const submitForm = () => {
    authenticationStore.loginDetails.email = email.value
    authenticationStore.loginDetails.password = password.value
    authenticationStore.login(jwt.default.generateNBF())
  }

  /**
   * @param response  = token received from google
   *
   * parses received token and assign to authentication store credentials
   */
  const handleCredentialResponse = ({ credential }: { credential: any }) => {
    const responsePayload = credential
    const googleCredentials = verifyToken(responsePayload)
    const payload = {
      email: googleCredentials.email,
      email_verified: googleCredentials.email_verified,
      last_name: googleCredentials.family_name,
      first_name: googleCredentials.given_name,
      full_name: googleCredentials.name,
      photo: googleCredentials.picture || "",
    }
    authenticationStore.loginDetails.google_token = jwt.default.generateToken(payload, jwt.default.generateNBF())
    authenticationStore.login(jwt.default.generateNBF(), undefined, gtm, googleCredentials.email)
  }

  // initializes google api for google button
  const googleInit = () => {
    // eslint-disable-next-line no-undef
    google.accounts.id.initialize({
      client_id: "779082346605-6f9d8to1hni6bjajmtpi3a8146lm1lkn.apps.googleusercontent.com",
      callback: handleCredentialResponse,
      context: "signin",
      ux_mode: "popup",
      close_on_tap_outside: "false",
      auto_select: "true",
      auto_prompt: "false",
    })
    // eslint-disable-next-line no-undef
    google.accounts.id.renderButton(
      document.getElementById("googleButton"),
      { size: "large", logo_alignment: "center" } // customization attributes
    )
  }

  /**
   *
   * @param response  - google jwt
   * parses the payload of  google jwt
   */
  const verifyToken = (response: string) => {
    try {
      const parsed = JSON.parse(atob(response.split(".")[1]))
      return parsed
    } catch (e) {
      return null
    }
  }

  watch(
    () => authenticationStore.loginDetails,
    (val) => {
      email.value = val.email
    },
    { deep: true }
  )

  onUpdated(() => {
    email.value = authenticationStore.loginDetails.email
  })

  onMounted(() => {
    email.value = authenticationStore.loginDetails.email
    googleInit()
  })

return (_ctx: any,_cache: any) => {
  const _component_ion_button = _resolveComponent("ion-button")!

  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(WbTemplate, null, {
        default: _withCtx(() => [
          _createVNode(FormContainer, {
            "validation-schema": _unref(validationSchema),
            class: "flex flex-col w-[30rem] items-center justify-center text-light-black",
            onValid: submitForm
          }, {
            default: _withCtx(() => [
              _hoisted_1,
              _createElementVNode("div", _hoisted_2, [
                _createVNode(WbInput, {
                  modelValue: email.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
                  name: "email",
                  placeholder: "Email *",
                  autocomplete: "off"
                }, null, 8, ["modelValue"]),
                _createVNode(WbPassword, {
                  modelValue: password.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
                  name: "password",
                  type: "password",
                  placeholder: "Password",
                  autocomplete: "off"
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(WbCheckbox, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Remember me")
                    ]),
                    _: 1
                  }),
                  _hoisted_4
                ]),
                _createVNode(_component_ion_button, {
                  expand: "block",
                  type: "submit",
                  "native-type": "submit"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Continue")
                  ]),
                  _: 1
                }),
                _hoisted_5,
                _hoisted_6
              ]),
              _hoisted_7
            ]),
            _: 1
          }, 8, ["validation-schema"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})